import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

export default function AuthShell({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-[#3b1c5a] via-[#7b3f8c] to-[#d16ba5] p-6">
      {/* blobs decorativos (leve, sem animação pesada) */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-80 w-80 -translate-x-1/2 rounded-full bg-white/10 blur-3xl" />

      <Card className="relative w-full max-w-md border-white/20 bg-white/95 shadow-2xl backdrop-blur">
        <CardHeader className="space-y-2">
          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-[#6a3093] to-[#a044ff] text-white">
              ◆
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-sm font-semibold tracking-wide text-muted-foreground">NEXORA</span>
              <span className="text-xs text-muted-foreground">CRM Intelligence</span>
            </div>
          </div>

          <div className="pt-2">
            <CardTitle className="text-2xl">{title}</CardTitle>
            {description ? <CardDescription>{description}</CardDescription> : null}
          </div>
        </CardHeader>

        <CardContent className="space-y-4">
          {children}
          {footer ? <div className="pt-2">{footer}</div> : null}
        </CardContent>
      </Card>
    </div>
  );
}


